import React, { createContext, useContext, useState, useEffect } from 'react';
import authService from '@/services/authService';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = async () => {
    const authStatus = authService.isAuthenticated();
    const role = authService.getUserRole();
    
    setIsAuthenticated(authStatus);
    setUserRole(role);
    
    if (authStatus) {
      try {
        const profile = await authService.getCurrentUser();
        setUserProfile(profile);
      } catch (error) {
        console.error('Failed to fetch user profile:', error);
      }
    }
    
    setLoading(false);
  };

  const login = async (username, password) => {
    const result = await authService.login(username, password);
    if (result.success) {
      setIsAuthenticated(true);
      setUserRole(result.userRole);
      setUserProfile(result.userProfile);
      
      if (!result.userProfile && result.userRole) {
        try {
          const profile = await authService.getCurrentUser();
          setUserProfile(profile);
        } catch (error) {
          console.error('Failed to fetch user profile after login:', error);
        }
      }
    }
    return result;
  };

  const logout = async () => {
    await authService.logout();
    setIsAuthenticated(false);
    setUserRole(null);
    setUserProfile(null);
  };

  const value = {
    isAuthenticated,
    userRole,
    userProfile,
    login,
    logout,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}